export default class Range {
    constructor(start, end) {
        this.start = start
        this.end = end
    }

    contains(date) {
        return this.start <= date && date <= this.end
    }

    intersect(range) {
        return this.contains(range.start) || this.contains(range.end)
    }

    isContainedBy(range) {
        return this.start > range.start && this.end < range.end
    }

    merge(range) {
        if (this.start > range.start) {
            this.start = range.start
        }
        if (this.end < range.end) {
            this.end = range.end
        }
        return this
    }

    isStartRange(date) {
        return date.toDateString() == this.start.toDateString()
    }

    isEndRange(date) {
        return date.toDateString() == this.end.toDateString()
    }

    toTimeStamps(sec = false) {
        return [this.start.getTime() / (sec ? 1000 : 1), this.end.getTime() / (sec ? 1000 : 1)]
    }

    static fromTimeStamps(range, sec = false) {
        return new Range(new Date(range[0] * (sec ? 1000 : 1)), new Date(range[1] * (sec ? 1000 : 1)))
    }
}